import { useState } from 'react';
import { MapContainer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import BaseLayers from './BaseLayers';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const MODES = [
    { value: 'walk', label: 'پیاده' }, { value: 'bike', label: 'دوچرخه' },
    { value: 'drive', label: 'خودرو' }, { value: 'transit', label: 'حمل‌ونقل عمومی' },
];

function MapClickHandler({ onPick }) {
    useMapEvents({ click(e) { onPick([e.latlng.lat, e.latlng.lng]); } });
    return null;
}

export default function CommuteAnchorForm({ initial = null, onSave, onCancel }) {
    // Normalise location from either {lat,lon} or GeoJSON Point {coordinates:[lng,lat]}
    const initLatLon = (() => {
        const loc = initial?.location;
        if (!loc) return { lat: '', lon: '' };
        if (loc.type === 'Point' && Array.isArray(loc.coordinates)) {
            const [lng, lat] = loc.coordinates;
            if (isFinite(lat) && isFinite(lng)) return { lat, lon: lng };
        }
        const lat = loc.lat ?? loc.latitude;
        const lon = loc.lon ?? loc.lng ?? loc.longitude;
        if (isFinite(parseFloat(lat)) && isFinite(parseFloat(lon))) return { lat, lon };
        return { lat: '', lon: '' };
    })();

    const [label, setLabel] = useState(initial?.label || '');
    const [lat, setLat]     = useState(initLatLon.lat);
    const [lon, setLon]     = useState(initLatLon.lon);
    const [mode, setMode]   = useState(initial?.mode || 'drive');
    const [maxMin, setMaxMin] = useState(initial?.max_duration_min || '');
    const [days, setDays]   = useState(initial?.days_per_week || 5);
    const [err, setErr]     = useState('');

    const markerPos = lat !== '' && lon !== '' ? [parseFloat(lat), parseFloat(lon)] : null;

    const handleSave = () => {
        if (!label.trim()) { setErr('نام مقصد الزامی است.'); return; }
        if (!lat || !lon)  { setErr('لطفاً موقعیت را روی نقشه انتخاب کنید.'); return; }
        if (!maxMin)       { setErr('حداکثر زمان رفت‌وآمد الزامی است.'); return; }
        setErr('');
        onSave({ label: label.trim(), location: { lat: parseFloat(lat), lon: parseFloat(lon) }, mode, max_duration_min: Number(maxMin), days_per_week: Number(days) });
    };

    return (
        <div className="caf-wrap">
            <div className="prw-field">
                <label className="prw-label">نام مقصد</label>
                <input className="prw-input" placeholder="مثال: محل کار، مدرسه" value={label} onChange={e => setLabel(e.target.value)} />
            </div>
            <div className="prw-field">
                <label className="prw-label">موقعیت مقصد <span className="caf-map-hint-inline"> — روی نقشه کلیک کنید</span></label>
                <div className="caf-map-wrap">
                    <MapContainer center={markerPos || [35.6892, 51.389]} zoom={12} className="caf-map" key={initial?.id ?? 'new'}>
                        <BaseLayers position="topright" />
                        <MapClickHandler onPick={([la, lo]) => { setLat(parseFloat(la.toFixed(6))); setLon(parseFloat(lo.toFixed(6))); }} />
                        {markerPos && <Marker position={markerPos} />}
                    </MapContainer>
                </div>
                {markerPos && <p className="caf-coords-readout">📍 {parseFloat(lat).toFixed(5)}, {parseFloat(lon).toFixed(5)}</p>}
            </div>
            <div className="s3-row">
                <div className="prw-field">
                    <label className="prw-label">وسیله نقلیه</label>
                    <select className="prw-select" value={mode} onChange={e => setMode(e.target.value)}>
                        {MODES.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                    </select>
                </div>
                <div className="prw-field">
                    <label className="prw-label">حداکثر زمان (دقیقه)</label>
                    <input className="prw-input" type="number" min="1" max="180" placeholder="مثال: ۳۰" value={maxMin} onChange={e => setMaxMin(e.target.value)} />
                </div>
            </div>
            <div className="prw-field">
                <label className="prw-label">روزهای هفته: <strong>{days}</strong> روز</label>
                <input type="range" min="1" max="7" value={days} onChange={e => setDays(e.target.value)} className="caf-range" />
                <div className="caf-range-labels"><span>۱</span><span>۷</span></div>
            </div>
            {err && <p className="prw-error">{err}</p>}
            <div className="caf-actions">
                <button type="button" className="prw-btn prw-btn-secondary" onClick={onCancel}>انصراف</button>
                <button type="button" className="prw-btn prw-btn-primary" onClick={handleSave}>ذخیره</button>
            </div>
        </div>
    );
}
